module.exports = __webpack_public_path__ + "static/media/logo.12dd7b00.jpg";